import { isCustomSupplier } from '@bridebook/web/lib/supplier/hooks/query/use-supplier';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { SectionContainer } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/section-container';
import {
  BodyText,
  Header2,
  Header3,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/typography';
import { useWeddingWebsiteData } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/data/data-context';
import { Map } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/sections/venue/map';
import { getSupplierAddressText } from '@bridebook/web/lib/wedding-website/utils/get-supplier-address-text';
import { getPhotosWithPath, getPhotoUrl } from '@bridebook/web/app-shared/lib/supplier/utils';
import { ImageX } from '@bridebook/ui';
import { isVenueSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { Flex } from '@bridebook/aura';
import { VenueCarousel } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/sections/venue/venue-carousel';
import {
  AUTOPLAY_INTERVAL,
  VENUE_CAROUSEL_IMAGE,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/constants';

export const Venue = () => {
  const { t } = useTranslation('weddingWebsite');
  const { mainSupplier, mainSupplierPhotos, website } = useWeddingWebsiteData();
  const venueSection = website.sections.find(isVenueSection);
  const hasBBSupplier = !!mainSupplier && !isCustomSupplier(mainSupplier);
  const showVenuePhotos = venueSection?.data.useVenuePhotos ?? false;

  const photoUrls = useMemo(
    () => getPhotosWithPath(mainSupplierPhotos).map(getPhotoUrl).slice(0, 5),
    [mainSupplierPhotos],
  );

  const hasPhotos = photoUrls.length > 0;
  const hasSinglePhoto = photoUrls.length === 1;

  return (
    <SectionContainer
      className="w-full px-0 @screen-lg:px-10"
      detailsSectionId="venue"
      previewSectionId="venue">
      <Header2 className="w-full px-8 @screen-lg:px-0">
        {t('previewMode.tile.ourVenue.title')}
      </Header2>
      <Flex className="w-full flex-col gap-4 px-8 @screen-lg:px-0">
        <Header3>{mainSupplier?.name}</Header3>
        {mainSupplier && (
          <BodyText weight="subheader">{getSupplierAddressText(mainSupplier)}</BodyText>
        )}
        {!mainSupplier && (
          <BodyText weight="subheader">{t('previewMode.tile.venue.toBeConfirmed')}</BodyText>
        )}
      </Flex>
      {hasBBSupplier && showVenuePhotos && hasPhotos && (
        <div className="w-full" style={{ maxWidth: VENUE_CAROUSEL_IMAGE.width }}>
          {hasSinglePhoto ? (
            <ImageX
              src={photoUrls[0]}
              w={VENUE_CAROUSEL_IMAGE.width}
              h={VENUE_CAROUSEL_IMAGE.height}
            />
          ) : (
            <VenueCarousel
              images={photoUrls}
              imageWidth={VENUE_CAROUSEL_IMAGE.width}
              imageHeight={VENUE_CAROUSEL_IMAGE.height}
              autoplayInterval={AUTOPLAY_INTERVAL.venue}
            />
          )}
        </div>
      )}
      {hasBBSupplier && <Map supplier={mainSupplier} />}
    </SectionContainer>
  );
};
